import { memo } from "react";
import { cn } from "@/components/podkit/lib/cn";

export function GetStartedWithTasksShowcase() {
    return (
        <div className="m-auto flex max-w-screen-lg flex-col items-center justify-center p-16">
            <div className="mb-8 flex w-96 select-none flex-col items-center justify-center space-y-1">
                <ShowcaseListItem
                    title="Weekly digest"
                    description="Ready to review"
                    active
                    translateY={64}
                    scale={0.86}
                />
                <ShowcaseListItem
                    title="Add command palette"
                    description="Working…"
                    active={false}
                    translateY={32}
                    scale={0.93}
                />
                <ShowcaseListItem
                    title="Implement prompts API"
                    description="Starting environment…"
                    active={false}
                    translateY={0}
                    scale={1}
                />
            </div>
            <p className="mb-2 text-2xl text-[rgb(var(--ona-gray-100))]">Run cloud agents in parallel</p>
            <p className="text-center text-[rgb(var(--ona-gray-100))]">
                Clear your backlog with powerful coding agents working in ready-to-code cloud development environments
                for professional engineers.
            </p>
        </div>
    );
}

function ShowcaseListItem({
    title,
    description,
    active,
    translateY,
    scale,
}: {
    title: string;
    description: string;
    active: boolean;
    translateY: number;
    scale: number;
}) {
    return (
        <div
            className="flex w-full flex-col items-center justify-center rounded-[14px] bg-white bg-opacity-50 p-2 shadow-[0_0.5px_0.5px_0.5px_rgba(255,255,255,0.20)_inset,0_0.527px_10.532px_0_rgba(0,0,0,0.10)] backdrop-blur-lg"
            style={{
                transform: `translateY(${translateY}px) scale(${scale})`,
            }}
        >
            <div className="flex w-full flex-row items-center justify-start rounded-md bg-white p-4">
                <div
                    className={cn(
                        "mr-3 flex size-9 items-center justify-center rounded-md",
                        active ? "bg-[#CEFFC9]" : "bg-[#FCEADE]",
                    )}
                >
                    {active ? <ActiveDot /> : <InactiveDot />}
                </div>
                <div className="flex flex-col">
                    <p className="text-[rgb(var(--ona-gray-900))]">{title}</p>
                    <p className="text-base text-[rgb(var(--ona-gray-500))]">{description}</p>
                </div>
            </div>
        </div>
    );
}

const ActiveDot = memo(() => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27" fill="none">
            <circle cx="13.8114" cy="13.309" r="7.81872" fill="#A7F7A1" />
            <circle cx="13.8116" cy="13.3113" r="2.60624" fill="#0BD300" />
        </svg>
    );
});
ActiveDot.displayName = "ActiveDot";

const InactiveDot = memo(() => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
            <circle cx="14.5743" cy="14.0681" r="8.52127" fill="#FFDAC3" />
            <circle cx="14.5743" cy="14.0689" r="2.84043" fill="#EE6002" />
        </svg>
    );
});
InactiveDot.displayName = "InactiveDot";
